import { createContext, useContext } from 'react';

interface VenueProfileContextType {
  name: string;
  profileBanner: string | null;
  logo: string | null;
  type: string | null;
  priceCategory: string;
  address: {
    streetAddress1: string | null;
    city: string | null;
    state: string | null;
    latitude: number | null;
    longitude: number | null;
  } | null;
  description: string | null;
  slug: string;
  helloLeadFormUrl: string;
  menu: {
    menuItems: {
      id: string;
    }[];
    previewMenuItems: {
      id: string;
      name: string;
      image?: string;
    }[];
  };
}

export const VenueProfileContext = createContext<
  VenueProfileContextType | undefined
>(undefined);

export const useVenueProfile = () => {
  const venue = useContext(VenueProfileContext);

  if (!venue) {
    throw new Error(
      'useVenueProfile must be used within a VenueProfileProvider',
    );
  }

  return venue;
};
